import PaymentMethods from "../../../constants/PaymentMethods";
import BasketOrderItemPrice from "../../../entities/manhattan/basket/BasketOrderItemPrice";
import { IBasketOrderItemPrice, IBasketOrderPriceDiscount } from "../../../entities/manhattan/order/types";
import { IManhattanFactory } from "../types";
import { BasketPriceFactory } from "./BasketPriceFactory";


export const BasketOrderItemPriceFactory: IManhattanFactory = class BasketOrderItemPriceFactory {

  static create(basketOrderItemPrice: IBasketOrderItemPrice, quantity: number) {
    const discountTotal = basketOrderItemPrice.discounts?.reduce((sum: number, item: IBasketOrderPriceDiscount) => sum + Number(item.amount), 0);
    const amountWithIncludedDicount = basketOrderItemPrice.amount - discountTotal;
    const nOfInstallments = basketOrderItemPrice.installments === 0 ? 1 : basketOrderItemPrice.installments;
    const installmentPrice = basketOrderItemPrice.isPriceMonthlyAnnuity ? amountWithIncludedDicount : basketOrderItemPrice.amount / nOfInstallments;
    const installmentWithIncludedDiscount = (basketOrderItemPrice.paymentMethod === PaymentMethods.MONTHLY && !basketOrderItemPrice.isPriceMonthlyAnnuity) ?
      Number(basketOrderItemPrice.amount / nOfInstallments) - (discountTotal / Number(basketOrderItemPrice.installments)) : amountWithIncludedDicount;
    const basketPrice = BasketPriceFactory.create(basketOrderItemPrice, quantity);
    return new BasketOrderItemPrice(
      basketPrice.amount,
      installmentPrice,
      installmentWithIncludedDiscount,
      basketPrice.installments,
      discountTotal,
      basketPrice.discounts,
      basketPrice.grace,
      basketOrderItemPrice.paymentType,
      basketOrderItemPrice.paymentMethod,
      basketOrderItemPrice.participation,
      basketOrderItemPrice.isPriceMonthlyAnnuity,
      basketOrderItemPrice.isPaidOnCheckout
    );
  }

};
